import React, { useEffect, useState } from 'react';

import styles from './ExteriorCardPercentTitles.module.scss';
import { useTranslate } from 'react-polyglot';
import LineGraphCard from "../../../Cards/LineGraphCard/LineGraphCard";
import {useAxios} from "../../../../../../AxiosHandler";
import {useAuth} from "../../../../../../Auth";

function ExteriorCardPercentTitles(props: ExteriorCardPercentTitlesProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/exterior/breed/" + auth.selectedBreed + "/percent_title",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            if (res.data?.length != 0) {
                setData({
                    labels: res.data.map((i: any) => i["YEAR"]),
                    datasets: [
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.kip_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#68DB5A",
                            borderColor: "#68DB5A",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["KIP_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.zero_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#FFD700",
                            borderColor: "#FFD700",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ZERO_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.suff_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#FFA500",
                            borderColor: "#FFA500",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["SUFF_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.g_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#A9A9A9",
                            borderColor: "#A9A9A9",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["G_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.vg_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#5a7fdb",
                            borderColor: "#5a7fdb",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["VG_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.exc_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#db5ac6",
                            borderColor: "#db5ac6",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["EXC_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.ck_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#b53e2e",
                            borderColor: "#b53e2e",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["CK_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.bim_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#290b78",
                            borderColor: "#290b78",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["BIM_PERCENT"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.exterior.graphs.percent_title.bir_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#b51f92",
                            borderColor: "#b51f92",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["BIR_PERCENT"]),
                            tension: 0.5
                        }
                    ]
                });
            } else {
                setData(undefined);
            }
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.exterior.graphs.percent_title.title")}
                data={data}
                options={
                    {
                        scales: {
                            y: {
                                suggestedMin: 0,
                                suggestedMax: 100
                            }
                        }
                    }
                }
                description={t("statistics.areas.exterior.graphs.percent_title.description")}
            ></LineGraphCard>
        </div>
    );
}

class ExteriorCardPercentTitlesProps {
    onDataLoaded?: (data: any) => void;
}

export default ExteriorCardPercentTitles;
